import { BufferEditor } from '~/editor/BufferEditor/types.plate';
import { EditorEntityData } from '~/editor/helpers/EditorEntityData';
import { wrapNodeAtPosition } from '~/editor/transforms/wrapNodeAtPosition';
import { TextToNodeOptions } from '../../types';
import { LinkElement } from '../nodes/LinkElement';
import { findAndWrapNewLinks } from './findAndWrapNewLinks';

export const textToLinkNodes = (
  editor: BufferEditor,
  { entities }: TextToNodeOptions = {}
) => {
  // first wrap the links provided by serialize
  EditorEntityData.getLinks(entities).forEach((linkData) => {
    const linkElement = LinkElement.fromEntity(linkData);
    if (linkElement) {
      wrapNodeAtPosition(editor, linkElement, {
        start: linkData.start,
        length: linkData.length,
      });
    }
  });

  // and then wrap any other links
  findAndWrapNewLinks(editor);
};
